export type GenericFilterType = Record<string, string | Date | number | undefined>

export enum SortDirection {
  ASC = "asc",
  DESC = "desc"
}

export interface SortState {
  sortBy: string
  sortDirection: SortDirection
}
